export default __webpack_public_path__ + "static/media/mansory-page.c05aa41c.png";